import Vue from 'vue'
import ConfLoader from '@/api/confLoader'
import store from '@/store'

class AdminRoutesGenerator {
  generateRoutes (context = 'backoffice') {
    let loader = new ConfLoader(context)
    let config = loader.getConfiguration()
    let adminRoutes = []

    // Register routes for each entity
    for (let i in config) {
      if (config.hasOwnProperty(i)) {
        let entityName = config[i].entityName

        let customEditRoute = false
        let editRoute = true

        let customShowRoute = false
        let showRoute = true

        let customCreateRoute = false
        let createRoute = true

        let listRoute = true

        if (config[entityName].hasOwnProperty('customEdit')) {
          customEditRoute = config[entityName].customEdit
        } else if (config[entityName].hasOwnProperty('edit')) {
          editRoute = config[entityName].edit
        }

        if (config[entityName].hasOwnProperty('customCreate')) {
          customCreateRoute = config[entityName].customCreate
        } else if (config[entityName].hasOwnProperty('create')) {
          createRoute = config[entityName].create
        }

        if (config[entityName].hasOwnProperty('customShow')) {
          customShowRoute = config[entityName].customShow
        } else if (config[entityName].hasOwnProperty('show')) {
          showRoute = config[entityName].show
        }

        if (config[entityName].hasOwnProperty('list')) {
          listRoute = config[entityName].list
        }

        // List route
        if (listRoute) {
          let listC = Vue.component(`${entityName}-list`, function (resolve) {
            resolve({
              template: `<list-component entity-name="${entityName}" />`,
              components: {
                'listComponent': () => import('@/components/backoffice/listComponent')
              }
            })
          })

          adminRoutes.push({
            path: `${entityName}/list`,
            name: `${entityName}_list`,
            component: listC
          })
        }

        // Custom Show route
        if (customShowRoute) {
          adminRoutes.push({
            path: `${entityName}/:id/show`,
            name: `${entityName}_show`,
            component: () => import(`@/components/backoffice/show/customShowComponent/${entityName}`)
          })
        }

        // Show route
        else if (showRoute) {
          let viewC = Vue.component(`${entityName}-show`, function (resolve) {
            resolve({
              template: `<show-component entity-name="${entityName}" :id="$route.params.id"/>`,
              components: {
                'showComponent': () => import('@/components/backoffice/show/showComponent')
              }
            })
          })

          adminRoutes.push({
            path: `${entityName}/:id/show`,
            name: `${entityName}_show`,
            component: viewC
          })
        }

        // Custom Edit route
        if (customEditRoute) {
          adminRoutes.push({
            path: `${entityName}/:id/edit`,
            name: `${entityName}_edit`,
            component: () => import(`@/components/backoffice/edit/customEditComponent/${entityName}`)
          })
        }

        // edit route
        else if (editRoute) {
          let editC = Vue.component(`${entityName}-edit`, function (resolve) {
            resolve({
              template: `<form-component entity-name="${entityName}" :id="$route.params.id"/>`,
              components: {
                'formComponent': () => import('@/components/form/generator')
              }
            })
          })

          adminRoutes.push({
            path: `${entityName}/:id/edit`,
            name: `${entityName}_edit`,
            component: editC
          })
        }

        // Custom Create route
        if (customCreateRoute) {
          adminRoutes.push({
            path: `${entityName}/create`,
            name: `${entityName}_create`,
            component: () => import(`@/components/backoffice/create/customCreateComponent/${entityName}`)
          })
        }

        // create route
        else if (createRoute) {
          let createC = Vue.component(`${entityName}-create`, function (resolve) {
            resolve({
              template: `<form-component entity-name="${entityName}"/>`,
              components: {
                'formComponent': () => import('@/components/form/generator')
              }
            })
          })

          adminRoutes.push({
            path: `${entityName}/create/:parentEntity?/:id?`, // parent_id could be necessary
            name: `${entityName}_create`,
            component: createC
          })
        }
      }
    }

    for (let i in adminRoutes) {
      if (adminRoutes.hasOwnProperty(i)) {
        let route = adminRoutes[i]

        route.beforeEnter = (to, from, next) => {
          store.commit('adminRoutes/add', to)
          next()
        }
      }
    }

    // Return generated admin routes
    return adminRoutes
  }
}

export default AdminRoutesGenerator
